import styled from "styled-components";
import {
  Frame as UnstyledFrame,
  ActionList,
  palette,
  spacing,
} from "@conserveit/blocks";

export const Frame = styled(UnstyledFrame)`
  display: flex;
  overflow: hidden;
  min-height: calc(100vh - 245px);
`;

export const Menu = styled.div`
  flex: 0 20%;
  background-color: ${palette.neutral2};
  padding: ${spacing.default} ${spacing.loose};
  border-right: 2px solid ${palette.neutral4};
`;

export const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-grow: 1;
  min-height: 0;
`;

export const BoxWrapper = styled.div`
  flex-basis: 50%;
  min-height: 0;
  height: calc(100vh - 245px - 72px);
  overflow: hidden;
`;

export const StyledActionList = styled(ActionList)`
  position: absolute;
  top: 104px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
`;

export const SitesBoxWrapper = styled(BoxWrapper)`
  position: relative;
  border-right: 2px solid ${palette.neutral4};
`;

export const RulesBoxWrapper = styled(BoxWrapper)`
  position: relative;
  border-right: 2px solid ${palette.neutral4};
`;

export const SettingsBoxWrapper = styled(BoxWrapper)``;

export const Foot = styled.div`
  flex: 0 100%;
  background-color: ${palette.neutral2};
  border-top: 1px solid ${palette.neutral4};
  text-align: right;
  padding: 16px;
  height: 72px;
`;

export const BoxHeader = styled.header`
  padding: 0 ${spacing.snug};
`;

export const BoxHeading = styled.div`
  margin-top: ${spacing.snug};
  color: ${palette.neutral7};
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0px;
  line-height: 36px;
  text-transform: uppercase;
`;

export const BoxContent = styled.div`
  position: absolute;
  top: 106px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  overflow-y: auto;
`;

export const SitesBoxContent = styled(BoxContent)`
  padding: 0 ${spacing.tight};
`;
